import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer style={{
      background: '#1e3d20',
      color: '#8fb99a',
      fontFamily: 'Lato, sans-serif',
      padding: '48px 24px 32px',
      marginTop: '60px',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

        {/* Top section */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '32px', marginBottom: '40px' }}>

          {/* Brand */}
          <div>
            <div style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#f5f0e8', fontWeight: 700, marginBottom: '8px' }}>
              True Plant Value
            </div>
            <div style={{ fontSize: '9px', letterSpacing: '3px', textTransform: 'uppercase', color: '#4a7c59', marginBottom: '16px' }}>
              Rooted in Fair Value
            </div>
            <p style={{ fontSize: '13px', lineHeight: 1.6, color: '#8fb99a', margin: 0 }}>
              A free community-driven platform tracking real sold prices for rare and common houseplants.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <div style={{ fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase', color: '#f5f0e8', fontWeight: 700, marginBottom: '16px' }}>Quick Links</div>
            {[
              { label: 'Home', path: '/' },
              { label: 'Search Plants', path: '/search' },
              { label: 'Submit a Sale', path: '/submit' },
              { label: 'Spotted in the Wild', path: '/spotted' },
              { label: 'Blog', path: '/blog' },
      { label: 'About', path: '/about' },
            ].map(({ label, path }) => (
              <div key={label} style={{ marginBottom: '8px' }}>
                <span onClick={() => navigate(path)} style={{ fontSize: '13px', color: '#8fb99a', cursor: 'pointer', textDecoration: 'none' }}
                  onMouseEnter={(e) => e.target.style.color = '#f5f0e8'}
                  onMouseLeave={(e) => e.target.style.color = '#8fb99a'}
                >{label}</span>
              </div>
            ))}
          </div>

          {/* Legal */}
          <div>
            <div style={{ fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase', color: '#f5f0e8', fontWeight: 700, marginBottom: '16px' }}>Legal</div>
            <p style={{ fontSize: '12px', lineHeight: 1.7, color: '#8fb99a', margin: '0 0 12px' }}>
              All data on this site is submitted by community members and is provided for informational purposes only. True Plant Value does not guarantee the accuracy of any pricing data.
            </p>
            <p style={{ fontSize: '12px', lineHeight: 1.7, color: '#8fb99a', margin: '0 0 12px' }}>
              Prices vary by location, condition, and market conditions. Always do your own research before buying or selling.
            </p>
            <p style={{ fontSize: '12px', lineHeight: 1.7, color: '#8fb99a', margin: 0 }}>
              True Plant Value is not affiliated with eBay, Etsy, Facebook, Palmstreet, or any other marketplace.
            </p>
          </div>

          {/* Community */}
          <div>
            <div style={{ fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase', color: '#f5f0e8', fontWeight: 700, marginBottom: '16px' }}>Community</div>
            <p style={{ fontSize: '13px', lineHeight: 1.6, color: '#8fb99a', marginBottom: '16px' }}>
              This platform is built by plant lovers, for plant lovers. Help us grow by submitting your sales!
            </p>
            <button onClick={() => navigate('/submit')} style={{ background: 'linear-gradient(135deg, #2c4a2e, #4a7c59)', color: '#f5f0e8', border: 'none', borderRadius: '20px', padding: '10px 20px', fontSize: '12px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer', fontFamily: 'Lato, sans-serif' }}>
              Submit a Sale
            </button>
          </div>

        </div>

        {/* Divider */}
        <div style={{ borderTop: '1px solid rgba(143,185,154,0.15)', paddingTop: '24px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>

            <div style={{ fontSize: '12px', color: '#4a7c59' }}>
              © {year} True Plant Value. All rights reserved.
            </div>

            <div style={{ fontSize: '12px', color: '#4a7c59', textAlign: 'center' }}>
              Pricing data is user-submitted and for reference only. Not financial advice.
            </div>

            <div style={{ fontSize: '12px', color: '#4a7c59' }}>
              Made with 🌿 for the plant community
            </div>

          </div>

          {/* Disclaimer */}
          <div style={{ marginTop: '16px', padding: '12px 16px', background: 'rgba(0,0,0,0.2)', borderRadius: '10px' }}>
            <p style={{ fontSize: '11px', color: '#4a7c59', margin: 0, lineHeight: 1.6, textAlign: 'center' }}>
              ™ True Plant Value is a trademark of its owner. All plant names, cultivar names, and trademarks belong to their respective owners.
              Data submitted to this platform may be used to improve our community database.
              By submitting data you confirm you have the right to share it.
              True Plant Value reserves the right to remove any inaccurate or inappropriate submissions.
            </p>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;